export const PrivacyPolicyPt = () => (
  <div className="max-w-4xl mx-auto px-4 py-12 bg-white">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Política de Privacidade</h1>
        <p className="text-sm text-gray-600">Última atualização: 03 de fevereiro de 2025</p>
        <p>
          Esta Política de Privacidade descreve Nossas políticas e procedimentos sobre a coleta, uso e
          divulgação de Suas informações quando Você utiliza o Serviço e informa sobre Seus direitos
          de privacidade e como a lei protege Você.
        </p>
        <p>
          Utilizamos Seus Dados Pessoais para fornecer e melhorar o Serviço. Ao utilizar o Serviço, Você
          concorda com a coleta e uso das informações de acordo com esta Política de Privacidade.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Interpretação e Definições
        </h2>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Interpretação
        </h3>
        <p>
          As palavras cuja letra inicial está em maiúscula têm significados definidos nas condições
          a seguir. As definições abaixo terão o mesmo significado independentemente de aparecerem
          no singular ou no plural.
        </p>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Definições
        </h3>
        <p className="mb-4">Para os fins desta Política de Privacidade:</p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <p>
              <strong>Conta</strong> significa uma conta única criada para Você acessar Nosso Serviço ou
              partes do Nosso Serviço.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Afiliada</strong> significa uma entidade que controla, é controlada por ou está sob
              controle comum com uma parte, em que &quot;controle&quot; significa propriedade de 50% ou mais das
              ações, participação societária ou outros títulos com direito a voto para eleição de
              diretores ou outra autoridade gestora.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Empresa</strong> (referida como &quot;a Empresa&quot;, &quot;Nós&quot;,
              &quot;Nos&quot; ou &quot;Nosso&quot; neste Acordo) refere-se a Dont Tab.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Cookies</strong> são pequenos arquivos colocados em Seu computador, dispositivo móvel
              ou qualquer outro dispositivo por um site, contendo os detalhes do Seu histórico de navegação
              nesse site entre suas diversas utilizações.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>País</strong> refere-se a: Brasil
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Dispositivo</strong> significa qualquer dispositivo que possa acessar o Serviço, como computador,
              celular ou tablet digital.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Dados Pessoais</strong> são qualquer informação que se relacione a um indivíduo identificado ou
              identificável.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Serviço</strong> refere-se ao aplicativo web DontTab, incluindo todos os
              recursos, ferramentas e funcionalidades acessíveis através do Site, seja por meio de
              navegador web ou qualquer outro meio.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Provedor de Serviço</strong> significa qualquer pessoa física ou jurídica que processe os
              dados em nome da Empresa. Refere-se a empresas ou indivíduos terceiros
              contratados pela Empresa para facilitar o Serviço, fornecer o Serviço em nome da
              Empresa, realizar serviços relacionados ao Serviço ou auxiliar a Empresa na
              análise de como o Serviço é utilizado.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Dados de Uso</strong> refere-se a dados coletados automaticamente, seja gerados pelo
              uso do Serviço ou pela própria infraestrutura do Serviço (por exemplo, a
              duração de uma visita a uma página).
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Site</strong> refere-se a Dont Tab, acessível em{' '}
              <a
                href="https://donttab.com/"
                rel="external nofollow noopener noreferrer"
                target="_blank"
              >
                https://donttab.com/
              </a>
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Você</strong> significa o indivíduo que acessa ou utiliza o Serviço, ou a
              empresa ou outra pessoa jurídica em nome da qual tal indivíduo acessa ou utiliza
              o Serviço, conforme aplicável.
            </p>
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Coleta e Uso de Seus Dados Pessoais
        </h2>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Tipos de Dados Coletados
        </h3>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Dados Pessoais
        </h4>
        <p>
          Ao utilizar Nosso Serviço, podemos solicitar que Você nos forneça determinadas informações
          pessoalmente identificáveis que podem ser usadas para contatá-lo ou identificá-lo. Informações
          pessoalmente identificáveis podem incluir, mas não se limitam a:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <p>Endereço de e-mail</p>
          </li>
          <li className="text-gray-700">
            <p>Nome e sobrenome</p>
          </li>
          <li className="text-gray-700">
            <p>Informações de pagamento e faturamento (processadas por nosso provedor de pagamento terceirizado)</p>
          </li>
          <li className="text-gray-700">
            <p>Dados de Uso</p>
          </li>
        </ul>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Dados de Pagamento
        </h4>
        <p>
          Quando Você adquire uma assinatura ou realiza um pagamento através do Serviço, Suas informações
          de pagamento são coletadas e processadas diretamente por nosso processador de pagamento terceirizado,
          Stripe. Não armazenamos o número completo do Seu cartão de crédito, CVV ou outros dados sensíveis
          de pagamento em nossos servidores. Podemos receber e armazenar informações limitadas de faturamento
          do Stripe, como os últimos quatro dígitos do número do Seu cartão, bandeira do cartão, data de
          validade, endereço de cobrança e histórico de transações, exclusivamente para fins de gerenciar
          Sua assinatura, processar reembolsos e prevenir fraudes.
        </p>
        <p>
          A coleta e uso de Suas informações de pagamento pelo Stripe são regidos pela própria
          política de privacidade deles, disponível em{' '}
          <a
            href="https://stripe.com/privacy"
            rel="external nofollow noopener noreferrer"
            target="_blank"
          >
            https://stripe.com/privacy
          </a>
          .
        </p>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Dados de Uso
        </h4>
        <p>Os Dados de Uso são coletados automaticamente ao utilizar o Serviço.</p>
        <p>
          Os Dados de Uso podem incluir informações como o endereço de Protocolo de Internet do Seu Dispositivo (ex.: endereço
          IP), tipo de navegador, versão do navegador, as páginas do Nosso Serviço que Você visita, o horário
          e a data da Sua visita, o tempo gasto nessas páginas, identificadores únicos de dispositivo e outros
          dados de diagnóstico.
        </p>
        <p>
          Quando Você acessa o Serviço por ou através de um dispositivo móvel, podemos coletar determinadas
          informações automaticamente, incluindo, mas não se limitando a, o tipo de dispositivo móvel que Você utiliza,
          o ID único do Seu dispositivo móvel, o endereço IP do Seu dispositivo móvel, o sistema operacional móvel,
          o tipo de navegador de Internet móvel que Você utiliza, identificadores únicos de dispositivo e outros
          dados de diagnóstico.
        </p>
        <p>
          Também podemos coletar informações que Seu navegador envia sempre que Você visita Nosso Serviço ou
          quando Você acessa o Serviço por ou através de um dispositivo móvel.
        </p>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Tecnologias de Rastreamento e Cookies
        </h4>
        <p>
          Utilizamos Cookies e tecnologias de rastreamento similares para rastrear a atividade em Nosso Serviço e
          armazenar determinadas informações. As tecnologias de rastreamento utilizadas são beacons, tags e scripts para
          coletar e rastrear informações e para melhorar e analisar Nosso Serviço. As tecnologias que
          utilizamos podem incluir:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <strong>Cookies ou Cookies de Navegador.</strong> Um cookie é um pequeno arquivo colocado em Seu
            Dispositivo. Você pode instruir Seu navegador a recusar todos os Cookies ou a indicar quando um Cookie
            está sendo enviado. No entanto, se Você não aceitar os Cookies, pode não conseguir utilizar algumas
            partes do Nosso Serviço. A menos que Você tenha ajustado as configurações do Seu navegador para recusar
            Cookies, Nosso Serviço pode utilizar Cookies.
          </li>
          <li className="text-gray-700">
            <strong>Web Beacons.</strong> Determinadas seções do Nosso Serviço e nossos e-mails podem conter
            pequenos arquivos eletrônicos conhecidos como web beacons (também referidos como clear gifs, pixel tags
            e single-pixel gifs) que permitem à Empresa, por exemplo, contar usuários que
            visitaram essas páginas ou abriram um e-mail e para outras estatísticas relacionadas ao site (por
            exemplo, registrar a popularidade de determinada seção e verificar a integridade do sistema e do servidor).
          </li>
        </ul>
        <p>
          Os Cookies podem ser &quot;Persistentes&quot; ou &quot;de Sessão&quot;. Os Cookies Persistentes
          permanecem em Seu computador pessoal ou dispositivo móvel quando Você fica offline, enquanto os Cookies de Sessão
          são excluídos assim que Você fecha Seu navegador web. Você pode saber mais sobre cookies no{' '}
          <a
            href="https://www.termsfeed.com/blog/cookies/#What_Are_Cookies"
            rel="noreferrer"
            target="_blank"
          >
            site TermsFeed
          </a>{' '}
          .
        </p>
        <p>Utilizamos Cookies de Sessão e Persistentes para os fins estabelecidos abaixo:</p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <p>
              <strong>Cookies Necessários / Essenciais</strong>
            </p>
            <p>Tipo: Cookies de Sessão</p>
            <p>Administrados por: Nós</p>
            <p>
              Finalidade: Estes Cookies são essenciais para fornecer a Você os serviços disponíveis através do
              Site e para permitir que Você utilize algumas de suas funcionalidades. Eles ajudam a autenticar usuários
              e prevenir uso fraudulento de contas de usuário. Sem estes Cookies, os serviços que
              Você solicitou não podem ser fornecidos, e utilizamos estes Cookies apenas para fornecer a Você
              esses serviços.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Cookies de Política / Aceitação de Aviso de Cookies</strong>
            </p>
            <p>Tipo: Cookies Persistentes</p>
            <p>Administrados por: Nós</p>
            <p>
              Finalidade: Estes Cookies identificam se os usuários aceitaram o uso de cookies no
              Site.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Cookies de Funcionalidade</strong>
            </p>
            <p>Tipo: Cookies Persistentes</p>
            <p>Administrados por: Nós</p>
            <p>
              Finalidade: Estes Cookies nos permitem lembrar as escolhas que Você faz ao utilizar o Site,
              como lembrar seus dados de login ou preferência de idioma. O propósito destes
              Cookies é fornecer a Você uma experiência mais personalizada e evitar que Você tenha que
              reinserir suas preferências toda vez que utilizar o Site.
            </p>
          </li>
        </ul>
        <p>
          Para mais informações sobre os cookies que utilizamos e suas escolhas em relação aos cookies, visite
          nossa Política de Cookies ou a seção de Cookies de nossa Política de Privacidade.
        </p>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Análises e Provedores de Serviço Terceirizados
        </h4>
        <p>
          Podemos utilizar serviços de análise de terceiros para nos ajudar a entender como o Serviço é utilizado
          e melhorá-lo. Estes serviços podem coletar informações sobre Seu uso do Serviço,
          incluindo, mas não se limitando a, páginas visitadas, funcionalidades utilizadas, duração da sessão e
          interações com o Serviço. Os tipos de serviços terceirizados que podemos utilizar incluem:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <strong>Provedores de análise</strong> (ex.: Google Analytics, Mixpanel ou similares)
            que nos ajudam a entender padrões de uso e melhorar o Serviço.
          </li>
          <li className="text-gray-700">
            <strong>Serviços de monitoramento de erros</strong> (ex.: Sentry ou similar) que nos
            ajudam a identificar e corrigir bugs e erros no Serviço.
          </li>
          <li className="text-gray-700">
            <strong>Processadores de pagamento</strong> (ex.: Stripe) que tratam da cobrança de assinaturas
            e processamento de pagamentos.
          </li>
          <li className="text-gray-700">
            <strong>Provedores de autenticação</strong> (ex.: Supabase) que gerenciam a criação de
            contas de usuário e login.
          </li>
        </ul>
        <p>
          Estes provedores de serviço terceirizados possuem suas próprias políticas de privacidade que regem as
          informações que coletam. Encorajamos Você a revisar suas respectivas políticas de privacidade.
        </p>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Uso de Seus Dados Pessoais
        </h3>
        <p>A Empresa pode utilizar Dados Pessoais para os seguintes fins:</p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <p>
              <strong>Para fornecer e manter Nosso Serviço</strong>, incluindo para monitorar o uso do
              Nosso Serviço.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para gerenciar Sua Conta:</strong> para gerenciar Seu cadastro como usuário do
              Serviço. Os Dados Pessoais que Você fornece podem dar-lhe acesso a diferentes funcionalidades
              do Serviço que estão disponíveis para Você como usuário cadastrado.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para a execução de um contrato:</strong> o desenvolvimento, cumprimento e
              realização do contrato de compra dos produtos, itens ou serviços que Você
              adquiriu ou de qualquer outro contrato conosco através do Serviço.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para contatá-lo:</strong> Para contatá-lo por e-mail, ligações telefônicas, SMS ou outras
              formas equivalentes de comunicação eletrônica, como notificações push de aplicativo
              móvel sobre atualizações ou comunicações informativas relacionadas às
              funcionalidades, produtos ou serviços contratados, incluindo atualizações de segurança, quando
              necessário ou razoável para sua implementação.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para fornecer a Você</strong> notícias, ofertas especiais e informações gerais sobre
              outros bens, serviços e eventos que oferecemos e que são semelhantes àqueles que Você
              já adquiriu ou consultou, a menos que Você tenha optado por não receber tais
              informações.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para gerenciar Suas solicitações:</strong> Para atender e gerenciar Suas solicitações a Nós.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para transferências comerciais:</strong> Podemos utilizar Suas informações para avaliar ou
              realizar fusão, desinvestimento, reestruturação, reorganização, dissolução ou outra venda
              ou transferência de alguns ou todos os Nossos ativos, seja como empresa em funcionamento ou como parte de
              falência, liquidação ou procedimento similar, em que Dados Pessoais mantidos por Nós sobre
              usuários do Nosso Serviço estejam entre os ativos transferidos.
            </p>
          </li>
          <li className="text-gray-700">
            <p>
              <strong>Para outros fins</strong>: Podemos utilizar Suas informações para outros fins,
              como análise de dados, identificação de tendências de uso, determinação da eficácia de nossas
              campanhas promocionais e para avaliar e melhorar Nosso Serviço, produtos, serviços,
              marketing e sua experiência.
            </p>
          </li>
        </ul>
        <p>Podemos compartilhar Suas informações pessoais nas seguintes situações:</p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <strong>Com Provedores de Serviço:</strong> Podemos compartilhar Suas informações pessoais com
            Provedores de Serviço para monitorar e analisar o uso do Nosso Serviço, para contatá-lo.
          </li>
          <li className="text-gray-700">
            <strong>Para transferências comerciais:</strong> Podemos compartilhar ou transferir Suas informações
            pessoais em conexão com, ou durante negociações de, qualquer fusão, venda de ativos da Empresa,
            financiamento ou aquisição de toda ou parte de Nosso negócio por outra empresa.
          </li>
          <li className="text-gray-700">
            <strong>Com Afiliadas:</strong> Podemos compartilhar Suas informações com Nossas afiliadas, caso em
            que exigiremos que essas afiliadas honrem esta Política de Privacidade. As afiliadas
            incluem Nossa empresa controladora e quaisquer outras subsidiárias, parceiros de joint venture ou outras
            empresas que controlamos ou que estão sob controle comum conosco.
          </li>
          <li className="text-gray-700">
            <strong>Com parceiros comerciais:</strong> Podemos compartilhar Suas informações com Nossos parceiros
            comerciais para oferecer a Você determinados produtos, serviços ou promoções.
          </li>
          <li className="text-gray-700">
            <strong>Com outros usuários:</strong> quando Você compartilha informações pessoais ou de outra forma
            interage nas áreas públicas com outros usuários, tais informações podem ser visualizadas por todos os usuários
            e podem ser distribuídas publicamente externamente.
          </li>
          <li className="text-gray-700">
            <strong>Com Seu consentimento</strong>: Podemos divulgar Suas informações pessoais para qualquer
            outro fim com Seu consentimento.
          </li>
        </ul>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Retenção de Seus Dados Pessoais
        </h3>
        <p>
          A Empresa reterá Seus Dados Pessoais apenas pelo tempo necessário para os fins
          estabelecidos nesta Política de Privacidade. Reteremos e utilizaremos Seus Dados Pessoais na extensão
          necessária para cumprir nossas obrigações legais (por exemplo, se formos obrigados a reter
          seus dados para cumprir leis aplicáveis), resolver disputas e fazer cumprir nossos
          acordos e políticas legais.
        </p>
        <p>
          A Empresa também reterá Dados de Uso para fins de análise interna. Os Dados de Uso são
          geralmente retidos por um período de tempo mais curto, exceto quando esses dados são utilizados para fortalecer
          a segurança ou para melhorar a funcionalidade do Nosso Serviço, ou quando somos legalmente obrigados a
          reter esses dados por períodos mais longos.
        </p>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Transferência de Seus Dados Pessoais
        </h3>
        <p>
          Suas informações, incluindo Dados Pessoais, são processadas nos escritórios operacionais da Empresa
          e em quaisquer outros locais onde as partes envolvidas no processamento estejam localizadas. Isso significa
          que essas informações podem ser transferidas para — e mantidas em — computadores localizados fora
          de Seu estado, província, país ou outra jurisdição governamental onde as leis de
          proteção de dados podem diferir daquelas de Sua jurisdição.
        </p>
        <p>
          Seu consentimento a esta Política de Privacidade seguido do envio de tais informações
          representa Sua concordância com essa transferência.
        </p>
        <p>
          A Empresa tomará todas as medidas razoavelmente necessárias para garantir que Seus dados sejam tratados
          de forma segura e de acordo com esta Política de Privacidade e nenhuma transferência de Seus Dados Pessoais
          ocorrerá para uma organização ou país, a menos que existam controles adequados em vigor,
          incluindo a segurança de Seus dados e outras informações pessoais.
        </p>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Excluir Seus Dados Pessoais
        </h3>
        <p>
          Você tem o direito de excluir ou solicitar que auxiliemos na exclusão dos Dados Pessoais que
          coletamos sobre Você.
        </p>
        <p>
          Nosso Serviço pode dar a Você a capacidade de excluir determinadas informações sobre Você de dentro do
          Serviço.
        </p>
        <p>
          Você pode atualizar, alterar ou excluir Suas informações a qualquer momento fazendo login em Sua Conta,
          se tiver uma, e visitando a seção de configurações da conta que permite gerenciar Suas
          informações pessoais. Você também pode nos contatar para solicitar acesso, correção ou exclusão de quaisquer
          informações pessoais que Você nos forneceu.
        </p>
        <p>
          Observe, no entanto, que podemos precisar reter determinadas informações quando tivermos obrigação
          legal ou base legal para fazê-lo.
        </p>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Divulgação de Seus Dados Pessoais
        </h3>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Transações Comerciais
        </h4>
        <p>
          Se a Empresa estiver envolvida em uma fusão, aquisição ou venda de ativos, Seus Dados Pessoais podem ser
          transferidos. Forneceremos aviso antes que Seus Dados Pessoais sejam transferidos e passem a estar
          sujeitos a uma Política de Privacidade diferente.
        </p>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Cumprimento da lei
        </h4>
        <p>
          Em determinadas circunstâncias, a Empresa pode ser obrigada a divulgar Seus Dados Pessoais se
          exigido por lei ou em resposta a solicitações válidas de autoridades públicas (ex.: um
          tribunal ou uma agência governamental).
        </p>
        <h4 className="text-lg font-semibold mt-6 mb-4 text-gray-800">
          Outros requisitos legais
        </h4>
        <p>
          A Empresa pode divulgar Seus Dados Pessoais na crença de boa-fé de que tal ação é
          necessária para:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">Cumprir uma obrigação legal</li>
          <li className="text-gray-700">Proteger e defender os direitos ou propriedade da Empresa</li>
          <li className="text-gray-700">Prevenir ou investigar possível irregularidade em conexão com o Serviço</li>
          <li className="text-gray-700">Proteger a segurança pessoal dos Usuários do Serviço ou do público</li>
          <li className="text-gray-700">Proteger contra responsabilidade legal</li>
        </ul>
        <h3 className="text-xl font-semibold mt-8 mb-4 text-gray-800">
          Segurança de Seus Dados Pessoais
        </h3>
        <p>
          A segurança de Seus Dados Pessoais é importante para Nós, mas lembre-se de que nenhum método de
          transmissão pela Internet ou método de armazenamento eletrônico é 100% seguro. Embora
          nos esforcemos para utilizar meios comercialmente aceitáveis para proteger Seus Dados Pessoais, não
          podemos garantir sua segurança absoluta.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Notificação de Violação de Dados
        </h2>
        <p>
          Em caso de violação de dados que afete Seus Dados Pessoais, tomaremos as
          seguintes medidas:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            Investigaremos a violação prontamente e tomaremos medidas razoáveis para contê-la e
            remediá-la.
          </li>
          <li className="text-gray-700">
            Notificaremos os usuários afetados por e-mail dentro de um prazo razoável após tomarmos
            conhecimento da violação, e não mais tarde do que exigido pela lei aplicável.
          </li>
          <li className="text-gray-700">
            Notificaremos a autoridade supervisora relevante (como a ANPD do Brasil —
            Autoridade Nacional de Proteção de Dados) conforme exigido pela lei aplicável.
          </li>
          <li className="text-gray-700">
            Forneceremos informações sobre a natureza da violação, os dados afetados, as
            medidas tomadas para tratá-la e recomendações para Você se proteger.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Seus Direitos sob a Lei Brasileira de Proteção de Dados (LGPD)
        </h2>
        <p>
          Se Você estiver localizado no Brasil, Você tem direitos sob a Lei Geral de Proteção
          de Dados (LGPD — Lei nº 13.709/2018). Estes incluem o direito a:
        </p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          <li className="text-gray-700">
            <strong>Confirmação e acesso:</strong> Obter confirmação de se Seus Dados Pessoais
            estão sendo processados e acesso a tais dados.
          </li>
          <li className="text-gray-700">
            <strong>Correção:</strong> Solicitar a correção de Dados Pessoais incompletos, inexatos ou
            desatualizados.
          </li>
          <li className="text-gray-700">
            <strong>Anonimização, bloqueio ou exclusão:</strong> Solicitar anonimização,
            bloqueio ou exclusão de Dados Pessoais desnecessários ou excessivos, ou dados processados em
            descumprimento da LGPD.
          </li>
          <li className="text-gray-700">
            <strong>Portabilidade de dados:</strong> Solicitar a portabilidade de Seus Dados Pessoais para
            outro provedor de serviço ou produto.
          </li>
          <li className="text-gray-700">
            <strong>Exclusão:</strong> Solicitar a exclusão de Dados Pessoais processados com Seu
            consentimento, exceto quando a retenção for legalmente exigida.
          </li>
          <li className="text-gray-700">
            <strong>Informação sobre compartilhamento:</strong> Obter informações sobre quais entidades públicas e
            privadas Seus Dados Pessoais foram compartilhados.
          </li>
          <li className="text-gray-700">
            <strong>Revogação do consentimento:</strong> Revogar Seu consentimento a qualquer momento, com o
            entendimento de que isso não afetará a legalidade do processamento realizado antes
            da revogação.
          </li>
          <li className="text-gray-700">
            <strong>Apresentação de reclamação:</strong> Apresentar reclamação à ANPD (Autoridade
            Nacional de Proteção de Dados) em relação ao processamento de Seus Dados
            Pessoais.
          </li>
        </ul>
        <p>
          <strong>Base legal para o processamento:</strong> Processamos Seus Dados Pessoais com base em uma
          ou mais das seguintes bases legais sob a LGPD: (a) Seu consentimento; (b) cumprimento
          de obrigação legal ou regulatória; (c) execução de contrato ou procedimentos preliminares
          relacionados a contrato do qual Você é parte; (d) exercício de direitos em
          procedimentos judiciais, administrativos ou arbitrais; (e) proteção da vida ou segurança
          física; (f) Nossos interesses legítimos, desde que não sobreponham Seus direitos e liberdades
          fundamentais; ou (g) proteção ao crédito.
        </p>
        <p>
          <strong>Controlador de Dados:</strong> O DontTab é o controlador de Seus Dados Pessoais. Para
          exercer qualquer dos direitos listados acima ou para quaisquer dúvidas sobre proteção de dados,
          entre em contato conosco utilizando as informações fornecidas na seção &quot;Fale Conosco&quot;
          abaixo.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Privacidade de Crianças
        </h2>
        <p>
          Nosso Serviço não se destina a menores de 13 anos. Não coletamos intencionalmente
          informações pessoalmente identificáveis de menores de 13 anos. Se Você é pai ou
          responsável e está ciente de que seu filho nos forneceu Dados Pessoais, por favor
          entre em contato conosco. Se tomarmos conhecimento de que coletamos Dados Pessoais de menores de
          13 anos sem verificação do consentimento dos pais, tomaremos medidas para remover essas informações
          de nossos servidores.
        </p>
        <p>
          Se precisarmos nos basear no consentimento como base legal para processar Suas informações e Seu
          país exigir consentimento dos pais, podemos exigir o consentimento dos pais antes de
          coletarmos e utilizarmos essas informações.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Links para Outros Sites
        </h2>
        <p>
          Nosso Serviço pode conter links para outros sites que não são operados por Nós. Se Você clicar em
          um link de terceiros, será direcionado ao site desse terceiro. Aconselhamos fortemente que Você
          revise a Política de Privacidade de cada site que visitar.
        </p>
        <p>
          Não temos controle sobre e não assumimos responsabilidade pelo conteúdo, políticas de privacidade ou
          práticas de quaisquer sites ou serviços de terceiros.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Alterações nesta Política de Privacidade
        </h2>
        <p>
          Podemos atualizar Nossa Política de Privacidade de tempos em tempos. Notificaremos Você sobre quaisquer alterações
          publicando a nova Política de Privacidade nesta página.
        </p>
        <p>
          Informaremos Você por e-mail e/ou um aviso em destaque em Nosso Serviço, antes da alteração
          entrar em vigor e atualizaremos a data de &quot;Última atualização&quot; no topo desta Política de
          Privacidade.
        </p>
        <p>
          Recomendamos que Você revise esta Política de Privacidade periodicamente para quaisquer alterações. As alterações nesta
          Política de Privacidade entram em vigor quando são publicadas nesta página.
        </p>
        <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
          Fale Conosco
        </h2>
        <p className="mb-4">Se você tiver alguma dúvida sobre esta Política de Privacidade, Você pode nos contatar:</p>
        <ul className="list-disc pl-6 mb-8">
          <li className="text-gray-700">
            Por e-mail:{' '}
            <a
              className="text-blue-600 hover:underline"
              href="mailto:devnicknish@gmail.com"
            >
              devnicknish@gmail.com
            </a>
          </li>
        </ul>
      </div>
    </div>
);
